import { render, staticRenderFns } from "./OpenedOverlay.vue?vue&type=template&id=1ac8a29c&"
import script from "./OpenedOverlay.vue?vue&type=script&lang=js&"
export * from "./OpenedOverlay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports